import { Box, Tabs, Tab, RouteOutlinedIcon, RouteRoundedIcon, QueryStatsOutlinedIcon, MovieOutlinedIcon, MovieIcon } from 'src/components';
import { useIsMobile } from 'src/hooks';

export default function TripTrackingTabs({ tab, handleTabChange, label }) {
  const isMobile = useIsMobile();

  return (
    <Box sx={{ width: '100%', mb: 1, pr: isMobile ? 0 : 1}}>
        <Tabs
          value={tab}
          onChange={handleTabChange}
          variant="fullWidth"
          indicatorColor="primary"
          textColor="primary"
          sx={{
            minHeight: 36, 
            '& .MuiTabs-indicator': {
              height: 3
            }
          }}>
            
          <Tab
            icon={tab === 0 ? <RouteRoundedIcon fontSize="small" /> : <RouteOutlinedIcon fontSize="small" />}
            label={label}
            iconPosition="start"
            disableRipple
            sx={{
              minHeight: 36,
              padding: '6px 8px',
              fontSize: 13,
              fontWeight: 500
            }}
          />
          <Tab
            icon={<QueryStatsOutlinedIcon fontSize="small" />}
            label="Stats"
            iconPosition="start"
            disableRipple
            sx={{
              minHeight: 36,
              padding: '6px 8px',
              fontSize: 13,
              fontWeight: 500
            }}
          />
          <Tab
            icon={tab === 2 ? <MovieIcon fontSize="small" /> : <MovieOutlinedIcon fontSize="small" />}
            label="Create"
            iconPosition="start"
            disableRipple
            sx={{
              minHeight: 36,
              padding: '6px 8px',
              fontSize: 13,
              fontWeight: 500
            }}
          />
        </Tabs>
      </Box>
  );
}
